import { render } from "./VideoLanding.vue?vue&type=template&id=20ee66b0&scoped=true"
const script = {}

import "./VideoLanding.vue?vue&type=style&index=0&id=20ee66b0&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ee66b0"]])

export default __exports__